module.exports = __webpack_public_path__ + "static/media/S1N10-6.f5bc0923.svg";